import { render, staticRenderFns } from "./goodsManage.vue?vue&type=template&id=abc846ae&scoped=true&"
import script from "./goodsManage.vue?vue&type=script&lang=js&"
export * from "./goodsManage.vue?vue&type=script&lang=js&"
import style0 from "./goodsManage.vue?vue&type=style&index=0&id=abc846ae&scoped=true&lang=css&"
import style1 from "./goodsManage.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abc846ae",
  null
  
)

export default component.exports